import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

import * as ActionTypes from './actionTypes';

export const cleanCommercialUsersReducer = () => {
  return {
    'type': ActionTypes.CLEAN_COMMERCIAL_USERS,
  };
};

export const fetchCommercialUsers = () =>
  (dispatch) => {
    return dispatch(
      apiActionCreator({
        'endpoint': '/commercial/users',
        'authenticated': true,
        'types': [
          ActionTypes.FETCHING_COMMERCIAL_USERS,
          [
            () => {
              return {
                'type': ActionTypes.FETCHED_COMMERCIAL_USERS,
              };
            },
          ],
          [
            {
              'type': ActionTypes.FETCHED_COMMERCIAL_USERS_FAILED,
            },
            (error) => buildErrorMessage(error),
          ],
        ],
        'microservice': 'part',
        'method': 'GET',
      }),
    );
  };
